import { Editor as SlateEditor, Transforms } from 'slate';

import { textToSlate } from 'src/components/RichSlate'; // TODO: consider moving this to global scope
import { getCharactersPointsBoundaries, getParagraphsCharacterPoints } from './characterPoints';
import { getEditorParagraphs } from './queries';

export const applyEditorTextChanges = (editor, changes) => {
  const paragraphs = [...getEditorParagraphs(editor)];

  changes.forEach((change) => {
    // We need to get paragraphs character data for each change,
    // cause previous change might shift "text" paragraphs boundaries
    const paragraphsCharsPoints = getParagraphsCharacterPoints(editor, paragraphs);
    const paragraphCharsPoints = paragraphsCharsPoints[change.paragraph];
    if (!paragraphCharsPoints) {
      return;
    }

    const boundaries = getCharactersPointsBoundaries(
      paragraphCharsPoints,
      change.start,
      change.start + change.originText.length
    );
    if (boundaries) {
      Transforms.insertText(editor, change.newText, {
        at: {
          anchor: boundaries.start,
          focus: boundaries.end,
        },
      });
    }
  });
};

export const replaceSlateEditorValue = (editor, newEditorValue) => {
  if (!editor) {
    return;
  }

  // Remove selection, in order to mitigate "can't find node" errors
  Transforms.deselect(editor);

  // Remove existing nodes
  const children = [...editor.children];
  children.forEach((node) => editor.apply({ type: 'remove_node', path: [0], node }));

  // Add new nodes
  newEditorValue.forEach((node, i) => editor.apply({ type: 'insert_node', path: [i], node: node }));

  // Place cursor at the end of the new content
  const point = SlateEditor.end(editor, []);
  Transforms.select(editor, point);
};

export const replaceSlateEditorText = (editor, newTextValue) => {
  if (!editor || newTextValue == null) {
    return;
  }

  const newValue = textToSlate(newTextValue);
  replaceSlateEditorValue(editor, newValue);
};
